/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DIALOG_SIZE_SM, Dialog, DialogContentProps, DialogProps } from '@squiz/sds';
import { CDP_STRINGS } from 'apps/customer-data-platform/src/Constants/Strings.constants';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SuccessMetricDialogForm } from '../../forms/SuccessMetricDialogForm/SuccessMetricDialogForm';
import { SuccessMetricDialogProps } from './SuccessMetricDialog.props';

/**
 * The add/edit success metric dialog.
 */
export const SuccessMetricDialog = (props: SuccessMetricDialogProps): JSX.Element => {
  const { t } = useTranslation();

  // Labels
  const labels = useMemo(() => {
    return {
      successMetrics: t(CDP_STRINGS.successMetrics),
    };
  }, [t]);

  const dialogProps: DialogProps = {
    dialogContent: {
      renderContent: (dialogContentProps: DialogContentProps): JSX.Element => {
        dialogContentProps.customProps = props;
        return <SuccessMetricDialogForm {...dialogContentProps} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM,
    heading: labels.successMetrics,
    scrollOnOverflow: false,
    showDividers: true,
    stateHandler: useDialogStore,
  };

  return <Dialog {...dialogProps} />;
};
